import { Info24Filled } from "@fluentui/react-icons";
import { useUseCase } from "../../../context/UseCaseContext/UseCaseContext";
import useCase2NameMapping from "../UsecaseMenu/UsecaseMapping";

import styles from "./UsecaseOverviewButton.module.css";

interface Props {
  className?: string;
  onClick: () => void;
}

export const UsecaseOverviewButton = ({ className, onClick }: Props) => {
  const { selectedUseCase } = useUseCase();

  return (
    <div className={`${styles.container} ${className ?? ""}`} onClick={onClick}>
      <Info24Filled />
      <span>
        {" "}
        {`About ${
          useCase2NameMapping.has(selectedUseCase)
            ? useCase2NameMapping.get(selectedUseCase)
            : selectedUseCase
        }`}{" "}
      </span>
    </div>
  );
};
